import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const APPLE_PAY: PaymentMethod = {
    id: PAYMENT_METHOD_ID.ApplePay,
    name: 'applepay',
    tokenRequired: true
};
